import { datadogRum } from '@datadog/browser-rum';

import { env } from './env';

export const init = () => {
  datadogRum.init({
    applicationId: '8aab16f6-93bd-48ee-907d-73483e8fd9ec',
    clientToken: 'pub4017bbe5d0b620322684d9cf98b0fb6c',
    site: 'datadoghq.com',
    service: 'trade-partner-portal',
    env: env,
    sampleRate: 100,
    trackInteractions: true,
    trackSessionAcrossSubdomains: true,
    allowedTracingOrigins: [
      'https://trade-partner-portal.managed.services.opendoor.com',
      'https://trade-partner.opendoor.com',
      'https://trade-partner-portal-staging.managed.services.opendoor.com',
      'https://trade-partner.simplersell.com',
    ],
  });
};
